import React from 'react'
import { makeStyles } from '@material-ui/core'
import { ReactComponent as ContactIcon } from 'src/assets/RiskReport_images/contactIcon.svg'
import { COLORS } from 'src/utils/Themes/colors'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
  },
  icon: {
    borderRadius: '8px',
    background: '#F1F1F1',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '10px',
    '& img': {
      flexShrink: 0,
      width: '24px',
      marginRight: '10px',
    },
    '& svg': {
      flexShrink: 0,
      width: '24px',
      marginRight: '10px',
    },
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  contactNumber: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: COLORS.DARK_PINK,
  },
  contactEmail: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
})

const CallToAction = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.icon}>
        <ContactIcon />
        Contact
      </div>
      <div className={classes.detailsContainer}>
        <div className={classes.contactNumber}>
          {INSURANCE_DETAILS?.HELP_MOBILE}
        </div>
        <div className={classes.contactEmail}>
          {INSURANCE_DETAILS?.SUPPORT_EMAIL}
        </div>
      </div>
    </div>
  )
}

export default CallToAction
